export type SectorCard = {
  slug: string;
  title: string;
  subcategories: string[];
  /** Placeholder sector — shown in grid but not selectable for discover search. */
  comingSoon?: boolean;
};

export const HOME_SECTOR_CARDS: SectorCard[] = [
  {
    slug: "automotive-mobility-ecosystem",
    title: "Automotive & Mobility",
    subcategories: [],
  },
  {
    slug: "industrial-automation-smart-manufacturing-ecosystem",
    title: "Industrial Automation & Smart Manufacturing",
    subcategories: [],
  },
  {
    slug: "textile-apparel-fashion-manufacturing-ecosystem",
    title: "Textile, Apparel & Fashion Manufacturing",
    subcategories: [],
  },
  {
    slug: "renewable-energy-electrification-ecosystem",
    title: "Renewable Energy & Electrification",
    subcategories: [],
  },
  {
    slug: "food-beverage-fmcg-ecosystem",
    title: "Food & FMCG",
    subcategories: [],
  },
  {
    slug: "healthcare-pharma-medtech-ecosystem",
    title: "Healthcare, Pharma & MedTech",
    subcategories: [],
  },
  {
    slug: "maritime-ports-offshore-ecosystem",
    title: "Maritime, Ports & Offshore",
    subcategories: [],
  },
  {
    slug: "chemicals-materials-advanced-manufacturing-ecosystem",
    title: "Chemicals & Advanced Manufacturing",
    subcategories: [],
  },
  {
    slug: "infrastructure-construction-smart-cities-ecosystem",
    title: "Infrastructure, Construction & Smart Cities",
    subcategories: [],
  },
  {
    slug: "agriculture-agritech-ecosystem",
    title: "Agriculture & AgroTech",
    subcategories: [],
  },
  {
    slug: "mining-metals-resources-ecosystem",
    title: "Mining, Metals & Resources",
    subcategories: [],
  },
  {
    slug: "digital-transformation-enterprise-technology-ecosystem",
    title: "Digital Transformation & Enterprise Technology",
    subcategories: [],
  },
];

export function getSectorBySlug(slug: string | undefined): SectorCard | null {
  if (!slug) return null;
  return HOME_SECTOR_CARDS.find((sector) => sector.slug === slug) ?? null;
}

/** Mirrors server `SECTOR_SLUG_BY_OPERATING_INDUSTRY` — maps head industry to sector dashboard slug. */
const INDUSTRY_TO_SECTOR_SLUG: Record<string, string> = {
  AUTOMOTIVE_AND_EV: "automotive-mobility-ecosystem",
  DEFENCE_AND_AEROSPACE: "automotive-mobility-ecosystem",
  MANUFACTURING_AND_INDUSTRIAL_AUTOMATION: "industrial-automation-smart-manufacturing-ecosystem",
  INDUSTRIAL_MACHINERY_TOOLS_AND_CAPITAL_EQUIPMENT: "industrial-automation-smart-manufacturing-ecosystem",
  TEXTILES_APPAREL_AND_TECHNICAL_FABRICS: "textile-apparel-fashion-manufacturing-ecosystem",
  POWER_AND_ENERGY: "renewable-energy-electrification-ecosystem",
  OIL_AND_GAS: "renewable-energy-electrification-ecosystem",
  CLIMATE_TECH_AND_SUSTAINABILITY: "renewable-energy-electrification-ecosystem",
  WATER_AND_ENVIRONMENTAL_SOLUTIONS: "renewable-energy-electrification-ecosystem",
  AGRICULTURE_AND_FOOD_PROCESSING: "agriculture-agritech-ecosystem",
  CONSUMER_PRODUCTS_AND_FMCG: "food-beverage-fmcg-ecosystem",
  PACKAGING_PRINTING_AND_CONVERTING_SOLUTIONS: "food-beverage-fmcg-ecosystem",
  HEALTHCARE_AND_LIFE_SCIENCES: "healthcare-pharma-medtech-ecosystem",
  SHIPPING_MARITIME_PORTS: "maritime-ports-offshore-ecosystem",
  CHEMICALS_AND_SPECIALTY_MATERIALS: "chemicals-materials-advanced-manufacturing-ecosystem",
  PLASTICS_POLYMERS_AND_RUBBER_MANUFACTURING: "chemicals-materials-advanced-manufacturing-ecosystem",
  CONSTRUCTION_AND_EPC: "infrastructure-construction-smart-cities-ecosystem",
  METALS_AND_MINERALS: "mining-metals-resources-ecosystem",
  MINING: "mining-metals-resources-ecosystem",
  ELECTRONICS_AND_SEMICONDUCTORS: "digital-transformation-enterprise-technology-ecosystem",
  ICT_AND_DIGITAL_TECH: "digital-transformation-enterprise-technology-ecosystem",
};

export function getSectorSlugByIndustry(industry: string | undefined | null): string | null {
  if (!industry?.trim()) return null;
  return INDUSTRY_TO_SECTOR_SLUG[industry.trim()] ?? null;
}

export function getSectorHref(slug: string): string {
  return `/sector/${encodeURIComponent(slug)}`;
}

export function getSectorPageHref(industry: string | undefined | null): string {
  const slug = getSectorSlugByIndustry(industry);
  if (slug) return getSectorHref(slug);
  const trimmed = industry?.trim();
  return trimmed ? `/ecosystem-heads/${encodeURIComponent(trimmed)}` : "/ecosystem-heads";
}
